import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { GrowingSpacer } from "@faire/web--source/slate/spacing";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import { useViewport } from "@faire/web--source/ui/hooks/useViewport";
import React, { useEffect, useRef } from "react";
import styled, { keyframes } from "styled-components";
import { setTimeoutIfPossible } from "@faire/retailer-visitor-shared/lib/async-functions/setTimeoutIfPossible";
import { FaireAndBrandLogo } from "./FaireAndBrandLogo";
import { SignUpButton } from "./SignUpButton";
var animationLength = 300;
var navHeightDesktop = 80;
var navHeightMobile = 80;
export var SignUpNavComponent = function(props) {
    var isMobile = useViewport().isMobile;
    var _React_useState = _sliced_to_array(React.useState(false), 2), animating = _React_useState[0], setAnimating = _React_useState[1];
    var prevProps = useRef(props);
    var timeout = useRef(undefined);
    useEffect(function() {
        if (prevProps.current.showNav && !props.showNav) {
            setAnimating(true);
            timeout.current = setTimeoutIfPossible(function() {
                setAnimating(false);
            }, animationLength);
        }
        prevProps.current = props;
    }, [
        props
    ]);
    useEffect(function() {
        return function() {
            clearTimeout(timeout.current);
        };
    }, []);
    var showNav = props.showNav, hideInput = props.hideInput, brandName = props.brandName;
    if (!showNav && !animating) {
        return null;
    }
    var Nav = showNav ? AppearingNav : DisappearingNav;
    return /*#__PURE__*/ _jsxs(Nav, {
        hideInput: hideInput,
        children: [
            !isMobile ? /*#__PURE__*/ _jsx(FaireAndBrandLogo, {
                brandName: brandName
            }) : null,
            /*#__PURE__*/ _jsx(GrowingSpacer, {}),
            /*#__PURE__*/ _jsx(SignUpButton, {
                primary: true
            })
        ]
    });
};
var SignUpNav = styled.nav.withConfig({
    componentId: "sc-b5ee8267-0"
})([
    "position:fixed;top:0;height:",
    "px;width:100%;background-color:#f9f5f0;display:flex;flex-direction:row;align-items:center;padding:0px 20px;box-shadow:0 1px 2px rgba(0,0,0,0.1);z-index:12;",
    "{height:",
    "px;padding:16px 18px;}",
    "{padding:0 24px;}"
], navHeightDesktop, responsiveMediaQueries.mobile, function(props) {
    return props.$hideInput ? navHeightDesktop : navHeightMobile;
}, responsiveMediaQueries.tablet);
var slideIn = keyframes([
    "0%{top:-",
    "px;}100%{top:0;}"
], navHeightDesktop);
var slideOut = keyframes([
    "0%{top:0px;}100%{top:-",
    "px;}"
], navHeightDesktop);
var slideInMobile = keyframes([
    "0%{top:-",
    "px;}100%{top:0;}"
], navHeightMobile);
var slideOutMobile = keyframes([
    "0%{top:0px;}100%{top:-",
    "px;}"
], navHeightMobile);
var AppearingNav = styled(SignUpNav).withConfig({
    componentId: "sc-b5ee8267-1"
})([
    "animation:",
    " ",
    "ms ease-in-out 0s;",
    "{animation:",
    " ",
    "ms ease-in-out 0s;}"
], slideIn, animationLength, responsiveMediaQueries.mobile, function(props) {
    return props.hideInput ? slideIn : slideInMobile;
}, animationLength);
var DisappearingNav = styled(SignUpNav).withConfig({
    componentId: "sc-b5ee8267-2"
})([
    "top:-",
    "px;animation:",
    " ",
    "ms ease-in-out 0s;",
    "{top:-",
    "px;animation:",
    " ",
    "ms ease-in-out 0s;}"
], navHeightDesktop, slideOut, animationLength, responsiveMediaQueries.mobile, function(props) {
    return props.hideInput ? navHeightDesktop : navHeightMobile;
}, function(props) {
    return props.hideInput ? slideOut : slideOutMobile;
}, animationLength);
